module.exports = __webpack_public_path__ + "img/close-dark-gray.6106ed9c.svg";